// extracted by mini-css-extract-plugin
export default {"fullWidth":"Wo-z","image":"Xo-z","lazyLoadPicture":"Yo-z","lazyLoadSpinner":"Zo-z","lazyLoadSpin":"_o-z","lazyLoadImage":"ap-z","hasStyledAspectRatio":"bp-z"};